import { setDefaultTool } from "./utils";

const registerEventHandler = (zwibbler, eventHandler, callFMScript) => {
  let batching;
  let params = [];
  const { fileName, scriptName } = eventHandler;
  const callBack = (event, data) => {
    const param = { event, data };

    const batch = param => {
      params.push(param);
      if (batching) {
        return;
      }

      batching = true;
      setTimeout(() => {
        callFMScript(fileName, scriptName, JSON.stringify(params));
        batching = false;
        params = [];
      }, 100);
    };
    batch(param);
  };
  zwibbler.on("tool-changed", data => callBack("tool-changed", data));
  zwibbler.on("document-changed", data => callBack("document-changed", data));
  zwibbler.on("selected-nodes", data => {
    const selectedNodeIds = zwibbler.getSelectedNodes();
    let properties = zwibbler.getPropertySummary(selectedNodeIds);
    callBack("selected-nodes", properties);
  });
  zwibbler.on("double-click", (x, y, node) => {
    const tag = zwibbler.getNodeProperty(node, "tag");
    callBack("double-click", { x, y, node, tag });
  });
};

/*global 
Zwibbler
*/
export default ({ config, document, eventHandler }, callFMScript) => {
  //additional configs just for godraw
  const defaultTool = config.defaultTool;
  delete config.defaultTool;
  //end

  config.showToolbar = false;

  let godrawConfig = {};
  let zwibDoc = null;
  if (document) {
    const godraw = document.godraw;
    zwibDoc = document.zwibbler;
    godrawConfig = godraw.config;
  }

  const finalConfig = Object.assign({}, config, godrawConfig);
  const zwibbler = Zwibbler.create("zwibbler", finalConfig);
  window.z = zwibbler;
  const bgImageInConfig = finalConfig.backgroundImage;

  if (zwibDoc) {
    zwibbler.load("zwibbler3." + JSON.stringify(zwibDoc));
  }

  if (bgImageInConfig) {
    zwibbler.setConfig("backgroundImage", bgImageInConfig);
  }

  if (defaultTool) {
    setDefaultTool(zwibbler, defaultTool);
  }

  //reset the background image if there is one. Workaround for a bug.
  const bgNode = zwibbler.findNode("background");

  if (bgNode) {
    const image = zwibbler.getNodeProperty(bgNode, "url");

    //can't set the background image if it is readOnly
    const isReadOnly = zwibbler.getConfig("readOnly");
    if (isReadOnly) {
      zwibbler.setConfig("readOnly", false);
    }
    zwibbler.setConfig("backgroundImage", image);
    if (isReadOnly) {
      zwibbler.setConfig("readOnly", true);
    }
  }

  if (eventHandler) {
    registerEventHandler(zwibbler, eventHandler, callFMScript);
  }

  return zwibbler;
};



// WEBPACK FOOTER //
// ./src/components/Zwibbler/createZwibbler.js